import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { RedeemablePackageDefinition } from 'src/app/models/package-definition';
import { PackagesService } from 'src/app/services/packages.service';
import { PaymentService } from 'src/app/services/payment.service';
import { GetGiftWithColleagueDialogComponent } from './get-gift-with-colleague-dialog/get-gift-with-colleague-dialog.component';
import { PurchaseResultDialogComponent } from './purchase-result-dialog/purchase-result-dialog.component';
import { GetGiftWithColleagueService } from './services/get-gift-with-colleague.service';
import { CheckoutStatusPoller } from './services/checkout-status-poller';
import { YoutubeVideoDialogComponent } from 'src/app/modules/shared/components/youtube-video-dialog/youtube-video-dialog.component';

@Component({
  selector: 'app-my-packages',
  templateUrl: './my-packages.component.html',
  styleUrls: ['./my-packages.component.scss'],
  providers: [
    GetGiftWithColleagueService
  ],
  standalone: false
})
export class MyPackagesComponent implements OnInit {
  isContentLoading: boolean = false;

  theoryPackageDefinitions: Array<RedeemablePackageDefinition> = [];
  practicePackageDefinitions: Array<RedeemablePackageDefinition> = [];
  miscPackageDefinitions: Array<RedeemablePackageDefinition> = [];
  inactivePackageDefinitions: Array<RedeemablePackageDefinition> = [];

  constructor(
    private packageService: PackagesService,
    private paymentService: PaymentService,
    private dialogService: MatDialog,
    private routerService: Router,
    private activatedRoute: ActivatedRoute,
    private viewContainerRef: ViewContainerRef
  ) { }

  public async ngOnInit(): Promise<void> {
    this.isContentLoading = true;

    await this.checkPurchaseResultIfExists();
    await this.loadPackageDefinitions();

    this.isContentLoading = false;
  }

  public async ngAfterViewInit(): Promise<void> {
    await this.showWelcomeVideoParamIfNeeded();
  }

  protected async loadPackageDefinitions(): Promise<void> {
    try {
      // Szuper spagetti Jenő kódja, ez kell, hogy működjön a kód..
      await this.packageService.getRedeemablePackages();

      const packageDefinitions: ReadonlyArray<RedeemablePackageDefinition> = (await this.packageService.getPackageDefinitions()).filter(
        (packageDefinition: RedeemablePackageDefinition) => {
          return (packageDefinition.isActive && packageDefinition.offers.some(offer => offer.offerFor === "vendor")) || packageDefinition.redeemableCount > 0
        }
      );

      this.theoryPackageDefinitions.length = 0;
      this.practicePackageDefinitions.length = 0;
      this.inactivePackageDefinitions.length = 0;

      for (const packageDefinition of packageDefinitions) {
        let targetPackageDefinitionsArray: Array<RedeemablePackageDefinition> | null = null;

        const isPackagePurchaseable: boolean = packageDefinition.isActive && packageDefinition.offers.filter(
          offer => offer.offerFor === "vendor"
        ).length > 0

        if (isPackagePurchaseable) {
          if (packageDefinition.groupName === "theory") {
            targetPackageDefinitionsArray = this.theoryPackageDefinitions;
          } else if (packageDefinition.groupName === "practical") {
            targetPackageDefinitionsArray = this.practicePackageDefinitions;
          } else {
            targetPackageDefinitionsArray = this.miscPackageDefinitions;
          }
        } else {
          targetPackageDefinitionsArray = this.inactivePackageDefinitions;
        }

        if (targetPackageDefinitionsArray) {
          targetPackageDefinitionsArray.push(packageDefinition);
        }

      }

    } catch (error: any) { }
  }


  public openPurchaseResultDialog(purchaseResult: "SUCCESS" | "FAILED", checkoutId?: string): void {
    const dialogRef: MatDialogRef<PurchaseResultDialogComponent> = PurchaseResultDialogComponent.openDialog(this.dialogService, {
      purchaseResult: purchaseResult,
      checkoutId: checkoutId
    });

    dialogRef.afterClosed().subscribe(
      async () => {
        this.loadPackageDefinitions();
        await this.routerService.navigate([], { relativeTo: this.activatedRoute, queryParams: {} });
      }
    )
  }

  private async checkPurchaseResultIfExists(): Promise<void> {
    const purchaseResultQueryParam: string | undefined = this.activatedRoute.snapshot.queryParams.purchase_result ?? undefined;
    const checkoutIdQueryParam: string | undefined = this.activatedRoute.snapshot.queryParams.checkout_session_id ?? undefined;

    if (purchaseResultQueryParam == "SUCCESS" || purchaseResultQueryParam == "FAILED") {
      this.openPurchaseResultDialog(purchaseResultQueryParam, checkoutIdQueryParam);
    }
  }

  private async showWelcomeVideoParamIfNeeded(): Promise<void> {
    const welcomeVideoParam: string | undefined = this.activatedRoute.snapshot.queryParams.welcome_video ?? undefined;
    console.log(this.activatedRoute.snapshot.queryParams);

    if (welcomeVideoParam === 'true') {
      // Open the YouTube video dialog
      YoutubeVideoDialogComponent.open(
        this.dialogService,
        { videoUrl: 'https://www.youtube.com/embed/y3Wu9Jv_O_Q?si=FGFe9FNga28AR9RD' }
      );

      // Remove the welcome_video parameter from URL
      const queryParams = { ...this.activatedRoute.snapshot.queryParams };
      delete queryParams['welcome_video'];
      await this.routerService.navigate([], {
        relativeTo: this.activatedRoute,
        queryParams: queryParams
      });
    }
  }

  public onGetGiftWithColleagueButtonClick(): void {
    GetGiftWithColleagueDialogComponent.open(this.dialogService, this.viewContainerRef);
  }
}
